import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronIcon } from '@wbk/svg';
import { Button } from '@wbk/ui';
import { ContentfulMedia } from '@wbk/contentful';
import { WebCard, WebSection } from '@wbk/contentful/api';
import ScrollTitle from '@/components/ui/ScrollTitle';
import useLocalization from '@/context/localization/useLocalization';

type Props = {
  section: WebSection;
};

const WorldSection = ({ section }: Props) => {
  const { t } = useTranslation('common');
  const { locale } = useLocalization();

  const items = section?.contentCollection?.items as WebCard[];

  return (
    <div className='container-padding container'>
      <div className='container flex flex-col justify-between gap-6 px-4 md:gap-10 lg:flex-row lg:items-center lg:space-y-12 xl:px-0'>
        <div className='flex w-full flex-row items-end justify-between gap-2 md:gap-8 lg:w-auto lg:flex-col lg:items-start'>
          <ScrollTitle title={section?.title} className='w-auto sm:max-w-xs' />

          <div className='flex shrink-0'>
            <Link to={`/${locale}/explore`}>
              <Button className='border-primary text-body-XS sm:text-body-S gap-1 rounded-full border bg-transparent px-4 py-1 capitalize transition-all duration-200 hover:bg-white/10 md:px-8'>
                {t('explore_things_to_do')}
                <ChevronIcon className='rtl:-rotate-180' />
              </Button>
            </Link>
          </div>
        </div>

        <div className='grid grid-cols-3 gap-2 sm:gap-3 md:grid-cols-5'>
          {items.map((item, index) => (
            <div
              key={index}
              className='h-18 flex items-center justify-center rounded-md border border-white/10 bg-transparent sm:h-16 sm:w-24'
            >
              <ContentfulMedia media={item?.image || item?.image11} className='w-full' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorldSection;
